import { Icon, IconButton } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import React from 'react';

import { configs } from '@hero/configs';
import { useGetBranding } from '@hero/services/organization-service/hooks';

import { CollectionDescription } from './CollectionDescription';
import { DigitalWrapper } from './DigitalWrapper';
import { Email } from './Email';
import { GiftMessage } from './GiftMessage';
import * as S from './style';

function GiftExperiencePreview({
  activeIndex,
  setActiveIndex,
  branding,
  messageParams,
  subject,
  selectedGreetingCard,
  activeGiftMessage
}) {
  const localeActiveIndex = configs?.experience?.greetingCardEnabled
    ? activeIndex
    : activeIndex - 1 || 0;

  const {
    branding: {
      logoUrl: defaultLogoUrl,
      giftWrappers: { default: defaultGiftWrapperUrl } = {}
    } = {}
  } = useGetBranding() || {};

  const logoUrl = branding?.logoUrl || defaultLogoUrl;
  const giftWrapperUrl = branding?.giftWrapperUrl || defaultGiftWrapperUrl;

  const SLIDER = [
    ...(configs?.experience?.greetingCardEnabled
      ? [
          {
            component: (
              <GiftMessage
                logoUrl={logoUrl}
                giftWrapperUrl={giftWrapperUrl}
                message={messageParams?.message}
                senderName={messageParams?.senderName}
                selectedGreetingCard={selectedGreetingCard}
                activeGiftMessage={activeGiftMessage}
              />
            )
          }
        ]
      : []),
    {
      component: (
        <GiftMessage
          logoUrl={logoUrl}
          giftWrapperUrl={giftWrapperUrl}
          message={messageParams?.message}
          senderName={messageParams?.senderName}
        />
      )
    },
    ...(subject
      ? [
          {
            component: <Email senderName={messageParams?.senderName} subject={subject} />
          }
        ]
      : []),
    ...(configs?.advanceSettings?.digitalWrapperEnabled
      ? [
          {
            component: <DigitalWrapper giftWrapperUrl={giftWrapperUrl} />
          }
        ]
      : []),
    ...(subject
      ? [
          {
            component: <CollectionDescription aboutMessage={messageParams?.aboutMessage} />
          }
        ]
      : [])
  ];

  const onPrevClick = () => {
    setActiveIndex(activeIndex - 1);
  };

  const onNextClick = () => {
    setActiveIndex(activeIndex + 1);
  };

  return (
    <S.GiftExperiencePreview>
      <S.GiftExperiencePreviewWrapper>
        <IconButton
          size="lg"
          variant="text"
          onClick={onPrevClick}
          disabled={localeActiveIndex === 0}
        >
          <Icon name="left-chevron" />
        </IconButton>
        <S.PhoneColumn>
          <S.PhonePreview>{SLIDER[localeActiveIndex]?.component}</S.PhonePreview>
          <S.DotWrapper>
            {SLIDER.map((_, index) => (
              <S.Dot
                key={index}
                name="experienceCarouselDot"
                active={localeActiveIndex === index}
                onClick={() => setActiveIndex(index + 1)}
              />
            ))}
          </S.DotWrapper>
        </S.PhoneColumn>
        <IconButton
          size="lg"
          variant="text"
          onClick={onNextClick}
          disabled={localeActiveIndex === SLIDER.length - 1}
        >
          <Icon name="right-chevron" />
        </IconButton>
      </S.GiftExperiencePreviewWrapper>
    </S.GiftExperiencePreview>
  );
}

GiftExperiencePreview.propTypes = {
  messageParams: PropTypes.shape({
    message: PropTypes.string,
    aboutMessage: PropTypes.string,
    senderName: PropTypes.string
  }),
  branding: PropTypes.shape({
    logoUrl: PropTypes.string,
    giftWrapperUrl: PropTypes.string
  }),
  activeIndex: PropTypes.number,
  setActiveIndex: PropTypes.func,
  subject: PropTypes.string,
  selectedGreetingCard: PropTypes.object,
  activeGiftMessage: PropTypes.string
};

export { GiftExperiencePreview };
